import { useTranslation as use18nextTranslation } from 'react-i18next';

import type { Translator } from './translation-types';

export const useTranslation = use18nextTranslation as () => { t: Translator };
